<template>
  <DefaultLayout>
    <div slot="content" class="py-12 px-5 text-center">
      <v-icon size="100" color="blue-grey darken-4">fa fa-exclamation-triangle fa-5x</v-icon>
      <h1 class="mt-6 mb-3">Access Denied</h1>
      <h2>Please contact your account admin for more information</h2>
    </div>
  </DefaultLayout>
</template>

<script>
import { mapState } from 'vuex';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'restrict',
  components: {
    DefaultLayout,
  },
  computed: {
    ...mapState({ signedInUser: state => state.auth.account }),
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ account: state => state.organizations.userSelectedAccount }),
  },
  watch:{
    organization() {
      if (this.checkpermissions()) {
        this.$router.push({ name: 'Home' });
      }
    },
    account() {
      if (this.checkpermissions()) {
        this.$router.push({ name: 'Home' });
      }
    },
  },
  methods: {
    checkpermissions() {
      return this.$store.getters.isProfileRequestViewer;
    }
  },
}
</script>
